import {
  type Dispatch,
  type ReactNode,
  type SetStateAction,
  createContext,
  useContext,
  useState,
} from "react";

type FilterType = "all" | "opened" | "resolved";

type FilterProviderType = {
  filter: FilterType;
  setFilter: Dispatch<SetStateAction<FilterType>>;
  isForMeFilter: boolean;
  setIsForMeFilter: Dispatch<SetStateAction<boolean>>;
};

const FilterProviderState: FilterProviderType = {
  filter: "opened",
  setFilter: () => {},
  isForMeFilter: false,
  setIsForMeFilter: () => {},
};

export const FilterContext =
  createContext<FilterProviderType>(FilterProviderState);

export const FilterProvider = ({ children }: { children: ReactNode }) => {
  const [filter, setFilter] = useState<FilterType>("opened");
  const [isForMeFilter, setIsForMeFilter] = useState(false);

  return (
    <FilterContext.Provider
      value={{
        filter,
        setFilter,
        isForMeFilter,
        setIsForMeFilter,
      }}
    >
      {children}
    </FilterContext.Provider>
  );
};

export const useFilter = () => {
  const context = useContext(FilterContext);
  if (context === undefined) {
    throw new Error("useFilter must be used within a FilterProvider");
  }
  return context;
};
